export default __webpack_public_path__ + "static/media/smartphone.e0b48150.svg";